/**
 * Inbox events — pub/sub minimalista para que cualquier componente pueda
 * pedir un refresh del inbox bell sin pasar referencias del hook por el árbol.
 *
 * Caso de uso: la marca acepta una sugerencia en /objectives, el backend mock
 * pushea una notif. Si no avisamos al hook `useInbox` (que vive en
 * DashboardLayout), el badge del bell tarda hasta 30s (polling) en actualizar.
 *
 * Patrón: window event. Idiomático, zero deps, perfecto para side-effects
 * cross-component sin state manager.
 *
 *   import { dispatchInboxRefresh } from "@/services/inbox-events";
 *   await api.acceptSuggestion(id);
 *   dispatchInboxRefresh(); // bell se actualiza al toque
 */

const INBOX_REFRESH_EVENT = "deenex:inbox:refresh";

/** Pedir un refresh del inbox bell desde cualquier componente */
export function dispatchInboxRefresh(): void {
    if (typeof window === "undefined") return;
    window.dispatchEvent(new CustomEvent(INBOX_REFRESH_EVENT));
}

/** Suscribirse a refresh events. Retorna unsubscribe. */
export function subscribeToInboxRefresh(handler: () => void): () => void {
    if (typeof window === "undefined") return () => {};
    window.addEventListener(INBOX_REFRESH_EVENT, handler);
    return () => window.removeEventListener(INBOX_REFRESH_EVENT, handler);
}
